import { render, staticRenderFns } from "./ksApplicationDrawer.vue?vue&type=template&id=bedbf1de&scoped=true"
import script from "./ksApplicationDrawer.vue?vue&type=script&lang=js"
export * from "./ksApplicationDrawer.vue?vue&type=script&lang=js"
import style0 from "./ksApplicationDrawer.vue?vue&type=style&index=0&id=bedbf1de&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bedbf1de",
  null
  
)

export default component.exports